import i18nProvider from './i18nProvider';

export { moment } from './i18nProvider';
export default i18nProvider;
